/* eslint-disable class-methods-use-this */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */
import BaseService, { CATEGORY_PORTAL } from "./core/BaseService";

interface PayloadBase {
    careerId: string;
    acceptManagerUserId?: string;
    acceptManagerUserId2?: string;
}
interface SaveStCancelCareerPayload extends PayloadBase {
    classId: string;
}

interface SaveStCancelCurriculumPayload extends PayloadBase {}

export interface SaveStCancelResponse {}

const CURRICULUM_FLG_CAREER = false;
const CURRICULUM_FLG_CURRICULUM = true;

class SaveStCancelService extends BaseService {
    constructor() {
        super(CATEGORY_PORTAL, "saveStCancel");
    }

    private setupPayload(payload: PayloadBase, curriculumFlg: boolean) {
        return { ...payload, curriculumFlg };
    }

    public async cancelAttendCareer(
        payload: SaveStCancelCareerPayload,
        resolved: (json: SaveStCancelResponse) => void,
        rejected: (error: any) => void
    ) {
        await super.postJSON(
            this.setupPayload(payload, CURRICULUM_FLG_CAREER),
            (json: any) => {
                const response = json as SaveStCancelResponse;
                resolved(response);
            },
            rejected
        );
    }

    public async cancelAttendCurriculum(
        payload: SaveStCancelCurriculumPayload,
        resolved: (json: SaveStCancelResponse) => void,
        rejected: (error: any) => void
    ) {
        await super.postJSON(
            this.setupPayload(payload, CURRICULUM_FLG_CURRICULUM),
            (json: any) => {
                const response = json as SaveStCancelResponse;
                resolved(response);
            },
            rejected
        );
    }
}

export default SaveStCancelService;
